'use strict';

const { pubdb } = Function('return this')();
const { $ } = pubdb;


$('button').live('click', function() {
    var b = $(this);
    $('#id').val(b.data('id'));
    $('#action').val(b.data('action'));
    $('form').submit();
    return false;
}).each(function () {
    var button = $(this);
    if (button.text() === 'True') {
        button.css('background-color', 'darkgreen');
    } else {
        button.css('background-color', 'crimson');
    }
});
